export const translationEngDefault = {
  SkhemataBlogCategories: {
    categoriesTitle: 'Categories',
    allCategories: 'All Categories',
  }
};
